<template>
  <v-card elevation="0" color="transparent">
    <v-row class="ma-3">
      <v-col>
        <h3>
          List of users with access
          <v-btn icon small color="primary" @click="openAddUserDialog()">
            <v-icon small>mdi-account-plus</v-icon>
          </v-btn>
        </h3>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="6" class="mx-6">
        <v-simple-table>
          <tbody>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <!--                  <th>Actions</th>-->
          </tr>
          <tr v-for="user in usersList" :key="user._id">
            <td>{{user.name}}</td>
            <td>{{user.email}}</td>
            <td>{{user.role}}</td>
            <td>
              <template v-if="!canEditStatus(userData, user)">
                <v-chip outlined small class="error error--text" v-if="user.status === 'inactive'">inactive</v-chip>
                <v-chip outlined small class="success success--text" v-else>active</v-chip>
              </template>
              <template v-else>
                <v-switch
                  :label="user.status === 'inactive' ? 'inactive' : 'active'"
                  :success="user.status !== 'inactive'"
                  :error="user.status === 'inactive'"
                  false-value="inactive"
                  true-value="active"
                  v-model="user.status"
                  @click="changeUserStatus(user)"
                ></v-switch>
              </template>
            </td>
            <!--                  <td>-->
            <!--                    <v-btn icon @click="editUser(user)"><v-icon>mdi-pencil</v-icon></v-btn>-->
            <!--                    <v-btn icon @click="deleteUser(user)"><v-icon>mdi-trash</v-icon></v-btn>-->
            <!--                  </td>-->
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <add-user-to-client-dialog ref="addUserToClient" :user-data="userData" @successCallback="emitUserAdded()"></add-user-to-client-dialog>
  </v-card>
</template>

<script>
  import AddUserToClientDialog from "../Dialogs/Settings/addUserToClientDialog";
  export default {
    name: "editListUsers",
    components: {AddUserToClientDialog},
    props: ['userData', 'usersList', 'refreshUsersList'],
    emits: ['userAdded', 'userStatusChanged'],
    methods: {
      openAddUserDialog(){
        this.$refs.addUserToClient.open = true;
      },
      emitUserAdded() {
        this.$emit('userAdded');
      },
      changeUserStatus(user) {
        this.$emit('userStatusChanged', user)
      },
      canEditStatus(userData, user) {
        switch (userData.role) {
          case 'superadmin':
            return user.role !== 'superadmin';
          case 'admin':
            return user.role === 'user';
          case 'user':
            return false
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sections/editListUsers.vue